import WhiteLogo from "../images/white-logo.webp"
import LogoWhite from "../images/logo-white.png"
import MainLogo from "../images/main-logo.webp"

const Images = {
  WhiteLogo,
  MainLogo,
  LogoWhite
}

export default Images